module.exports = __webpack_public_path__ + "static/p01_botonCuentamelo-1dfdb23588b572a6fd8dbea098a20bfe.png";